import React from 'react'

import ContentHeader from '../../components/ContentHeader'

class Header extends React.PureComponent {
  render() {
    return <ContentHeader title="REPORT: Annual Goal" showBackButton />
  }
}

export default Header
